import { useRatingApi } from "../api/RatingApiClient";
import { RatingFrontendService } from "../services/RatingFrontendService";

export const useRatingService = (): RatingFrontendService =>
  new RatingFrontendService(useRatingApi());
